import { AnimationPlaybackControls } from 'framer-motion';
import React from 'react';
import Card from './Card';

interface Props {
    animationRef: React.RefObject<AnimationPlaybackControls | null>;
}

const CardsContainer = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    
    <div className="cards-container" ref={ref}>
        {Array.from({ length: 7 }, (_, i) => i).map((num) => (
            <Card index={num} animationRef={props.animationRef}/>
        ))}
    </div>));

export default CardsContainer;